import { Box, Stack, Typography } from '@mui/material'
import BackNavButton from '../common/BackNavButton'

interface Props {
  title?: string
  description?: string
  sequenceNumber: number
}

export default function StageHeader({
  title = 'عنوان',
  description = 'یک زیر عنوان برای همه',
  sequenceNumber,
}: Props) {
  return (
    <Stack direction="row" gap={1} id="stage-header" sx={{ pl: { xs: 1, md: 2 } }}>
      <Box flexGrow={1}>
        <Typography fontSize="x-large" fontWeight="normal">
          {'مرحله ' + sequenceNumber.toLocaleString('fa-IR') + ' - ' + title}
        </Typography>
        <Typography fontSize="small" color="text.secondary">
          {description}
        </Typography>
      </Box>
      <Box>
        <BackNavButton />
      </Box>
    </Stack>
  )
}
